import { TemplatePageContentProvider } from '../Providers/TemplatePageContentContext'

export default function PageContextWrapper({page, page_content, children}) {
    return (
        <TemplatePageContentProvider
            page={page}
            key={page}
            page_content={page_content}
        >
            {children}
        </TemplatePageContentProvider>
    )
}
